import { Check, Info, Loader, X } from 'lucide-react';
import React, { useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import Spacing from '../Spacing';
import { datePickerFormat, exchangeDate, notify } from "../../helpers";
import { createAndUpdateRefrerral } from '../../services/easyReferral';
import { Config } from '../../Config';
import { Drawer } from 'vaul';

export default function ReferralEditInformationModal(props) {
  const {
    filter = {},
    setDataLoading = () => {},
    dataLoad = () => {},
    editReferral = {},
    setEditReferral = () => {},
    editReferralData = {},
    account_id,
    location_id,
    specialty_id,
    setViewImage = () => {},
    setOpenImageViewModal = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
  } = props;

  const [selectMedicalFiles, setSelectMedicalFiles] = useState([]);
  const [updateButtonLoader, setUpdateButtonLoader] = useState(false);
  const dropdownRef = useRef(null);

  const [referPatientData, setReferPatientData] = useState({
    account_id: account_id,
    location_id: location_id,
    specialty_id: specialty_id,
    patient_id: editReferralData?.patient_id ? editReferralData?.patient_id : "",
    refer_to_npi: editReferralData?.refer_to_npi ? editReferralData?.refer_to_npi : "",
    refer_to_state: editReferralData?.refer_to_state ? editReferralData?.refer_to_state : "",
    patient_conditon: editReferralData?.patient_conditon ? editReferralData?.patient_conditon : "",
    dos: editReferralData?.dos ? exchangeDate(editReferralData?.dos) : "",
    refer_date: editReferralData?.refer_date ? exchangeDate(editReferralData?.refer_date) : "",
    refer_end_date: editReferralData?.refer_end_date ? exchangeDate(editReferralData?.refer_end_date) : "",
    refer_reason: editReferralData?.refer_reason ? editReferralData?.refer_reason : "",
    active_medication_list: editReferralData?.active_medication_list ? editReferralData?.active_medication_list : "",
    diagnosis: editReferralData?.diagnosis ? editReferralData?.diagnosis : "",
    attach_medical_summary_files: [],
    refer_auth_code: editReferralData?.refer_auth_code ? editReferralData?.refer_auth_code : ""
  });

  const handleChangeReferDate = (name, value) => {
    setReferPatientData({
      ...referPatientData,
      [name]: datePickerFormat(value),
    });
  };

  const handleMedicalFileChange = (event) => {
    const files = Array.from(event.target.files);
    const acceptFileSize = Config?.uploadFileSizeLimit * 1024 * 1024;

    const validFiles = files.filter((file) => file.size <= acceptFileSize);
    const invalidFiles = files.filter((file) => file.size > acceptFileSize);

    if (invalidFiles.length > 0) {
      notify("error", `Exceed the size limit of ${Config?.uploadFileSizeLimit}MB`);
    }
    const updatedFiles = [...selectMedicalFiles, ...validFiles];
    setSelectMedicalFiles(updatedFiles);

    setReferPatientData({
      ...referPatientData,
      attach_medical_summary_files: updatedFiles,
    });
  };

  const removeFile = (index) => {
    const newFiles = selectMedicalFiles.filter((_, i) => i !== index);
    setSelectMedicalFiles(newFiles);

    setReferPatientData({
      ...referPatientData,
      attach_medical_summary_files: newFiles,
    });
  };

  const handleReferralChange = (e) => {
    const { name, value } = e.target;
    setReferPatientData({
      ...referPatientData,
      [name]: value
    });
  };

  const handleReferSubmit = async (e) => {
    e.preventDefault();
    setUpdateButtonLoader(true);
    e.target.disabled = true;

    try {
      const response = await createAndUpdateRefrerral(referPatientData);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          setDataLoading(true);
          dataLoad(filter);
          handleDrawerClose();
          notify("success", response?.data?.message);
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setUpdateButtonLoader(false);
    }

    e.target.disabled = false;
  };
   
  const handleDrawerClose = () => {
    setEditReferral(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={editReferral} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Edit Referral</Drawer.Title>
            <Drawer.Description className="sr-only">Edit a referral</Drawer.Description>
            <div className="docpro_modal_wrap docpro_modal_lg center">
              <div className="docpro_modal">
                <h2 className="docpro_fs_24">Edit Referral Patient</h2>

                <form onSubmit={handleReferSubmit}>
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_4">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Priority <span className="docpro_red_color">*</span>
                      </label>
                      <select className="docpro_form_field size_lg" name='patient_conditon' required value={referPatientData?.patient_conditon} onChange={handleReferralChange} >
                        <option value="Normal">Normal</option>
                        <option value="Critical">Critical</option>
                        <option value="Stat">Stat</option>
                      </select>
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        DOS <span className="docpro_red_color">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="mm/dd/yyyy"
                        className="docpro_form_field size_lg"
                        defaultValue={referPatientData.dos}
                        readOnly
                        disabled
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Referral Date <span className="docpro_red_color">*</span>
                      </label>
                      <div className="docpro_input_group">
                        <DatePicker
                          required
                          name="refer_date"
                          placeholder="mm/dd/yyyy"
                          className="size_lg"
                          selected={referPatientData.refer_date}
                          onChange={(date) =>
                            handleChangeReferDate("refer_date", date)
                          }
                        />
                      </div>
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        End Date <span className="docpro_red_color">*</span>
                      </label>
                      <div className="docpro_input_group">
                        <DatePicker
                          required
                          name="refer_end_date"
                          placeholder="mm/dd/yyyy"
                          className="size_lg"
                          selected={referPatientData.refer_end_date}
                          onChange={(date) =>
                            handleChangeReferDate("refer_end_date", date)
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <Spacing lg="15" sm="15" />
                  <div>
                    <label className="docpro_fw_500 docpro_primary_color">
                      Referral Reason <span className="docpro_red_color">*</span>
                    </label>
                    <textarea
                      required
                      minLength={2}
                      name="refer_reason"
                      className="docpro_form_field size_lg"
                      cols="30"
                      rows="4"
                      value={referPatientData.refer_reason}
                      onChange={handleReferralChange}
                      placeholder="Referral Reason"
                    ></textarea>
                  </div>

                  <Spacing lg="15" sm="15" />
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Active Medication List
                      </label>
                      <textarea
                        minLength={2}
                        name="active_medication_list"
                        className="docpro_form_field size_lg"
                        cols="30"
                        rows="4"
                        value={referPatientData.active_medication_list}
                        onChange={handleReferralChange}
                        placeholder="Active Medication List"
                      ></textarea>
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Diagnosis
                      </label>
                      <textarea
                        minLength={2}
                        name="diagnosis"
                        className="docpro_form_field size_lg"
                        cols="30"
                        rows="4"
                        value={referPatientData.diagnosis}
                        onChange={handleReferralChange}
                        placeholder="Diagnosis"
                      ></textarea>
                    </div>
                        
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Attach Medical Summary 
                        <button className="docpro_icon_btn overview pl-2" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                          <Info width={15} height={15} />
                          <div className="docpro_tip">
                            <span>Max file size {Config?.uploadFileSizeLimit}MB <br /> Accepted file types <br /> {Config?.acceptUploadFileType}</span>
                          </div>
                        </button>
                      </label>
                      <div className='input_file_conatiner'>
                        <label htmlFor="medical-file-upload" className='file_button'>
                          Choose Files
                        </label>
                        <input
                          type="file"
                          id="medical-file-upload"
                          name="attach_medical_summary_files[]"
                          multiple
                          accept={Config?.acceptUploadFileType}
                          className='file_hidden_input'
                          onChange={handleMedicalFileChange}
                        />
                        <span className='file_label'>{selectMedicalFiles?.length === 1 ? `${selectMedicalFiles?.length} File` : selectMedicalFiles?.length > 1 ? `${selectMedicalFiles?.length} Files` : 'No file chosen'}</span>
                      </div>

                      <ul className="mt-1 docpro_mb_0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                        {selectMedicalFiles.map((file, index) => (
                          <li key={index}>
                            <span onClick={() => removeFile(index)} className="docpro_red_color px-1 py-1" style={{ cursor: 'pointer' }}><X height={15} width={15} /></span>
                            <span className="pl-2">{file.name}</span>
                          </li>
                        ))}

                        {editReferralData?.attach_medical_summary_files?.map((file, index) => {
                          const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(file?.file_name);

                          return (
                            <li key={index}>
                              <span className="docpro_green_color px-1 py-1"><Check height={15} width={15} /></span>
                              <span className="docpro_green_color pl-2">
                                {file?.status === "success" ? (
                                  isImage ? (
                                    <span
                                      className='pointer'
                                      onClick={() => {
                                        setViewImage(`${Config?.FileUploadPortal}${file?.file_path}`);
                                        setOpenImageViewModal(true);
                                        setPreviousScrollPosition(window.scrollY);
                                        window.scrollTo(0, 0);
                                      }}
                                    >
                                      {file?.file_name}
                                    </span>
                                  ) : (
                                    <a href={`${Config?.FileUploadPortal}${file?.file_path}`} target="_blank" rel="noopener noreferrer">
                                      {file?.file_name}
                                    </a>
                                  )
                                ) : (
                                  <span title={`${file?.message}`}>{file?.file_name}</span>
                                )}
                              </span>
                            </li>
                          )
                        })}
                      </ul>
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Auth Code
                      </label>
                      <input
                        type="text"
                        placeholder="Auth Code"
                        className="docpro_form_field size_lg"
                        name="refer_auth_code"
                        value={referPatientData.refer_auth_code}
                        onChange={handleReferralChange}
                      />
                    </div>
                  </div>

                  <Spacing lg="32" sm="32" />
                  <div className="docpro_modal_btns">
                    <button
                      type='button'
                      className="docpro_bordered_btn docpro_fw_600 size_lg"
                      onClick={() => handleDrawerClose()}
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                      disabled={updateButtonLoader ? true : false}
                    >
                      <span>Update</span>
                      {updateButtonLoader && (
                        <span className="docpro_loading">
                          <Loader width={20} height={20} />
                        </span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
